import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class PushapiCountry extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            factorToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            factors: [],
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadFactors();
    }


    loadFactors() {
        this.setState({ isLoading: true });

        API.PushapiCountry.get().then(factors => this.setState({ factors, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, factorToUpdate: null });
    }

    handleFormSubmit(factor) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            factorToUpdate: null
        });

        API.PushapiCountry.save(factor).then(() => this.loadFactors());
    }

    handleRemoveBtnClick(type) {
        this.setState({ isLoading: true });

        API.PushapiCountry.remove(type).then(() => this.loadFactors());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['pushapi-eu', 'pushapi-us'], 'countryFactor', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                factor={this.state.factorToUpdate}/>;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Pushapi Country"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                {this.getForm()}

                <Table factors={this.state.factors} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick}/>
            </Container>
        );
    }
}

export default PushapiCountry;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCountry/index.js